import { createRouter, createWebHashHistory } from 'vue-router';
import staticRouter from './staticRouter';

const router = createRouter({
  history: createWebHashHistory(),
  routes: staticRouter,
})

export default router;